import { encodeLocationUrlPathSegmentFromMaybeEncoded } from '../location/encode-location-url-path-segment';
import { encodeOpaqueUrlPathSegment } from './encode-opaque-url-path-segment';
import { JOBS_LISTING_SEGMENTS } from '../constants/url-constants';

const SRP_PATH_WITH_DYNAMIC_SEGMENT = new RegExp(
  `^(/(?:en|fi|sv)/(?:${JOBS_LISTING_SEGMENTS.join('|')})/(?:location|alue|omrade|role|rooli|roll)/)([^/?]+)(.*)$`
);

function encodeDynamicSrpSegment(segment: string, isRoleSegment: boolean): string {
  if (isRoleSegment) {
    let decoded = segment;
    try {
      decoded = decodeURIComponent(segment);
    } catch {
      // keep raw when decoding fails
    }
    return encodeOpaqueUrlPathSegment(decoded);
  }
  return encodeLocationUrlPathSegmentFromMaybeEncoded(segment);
}

/**
 * Percent-encodes the location or role slug in an SRP path so UTF-8 and reserved
 * characters never appear literally. Idempotent when the segment is already encoded.
 */
export function encodeSrpPathForUrl(path: string): string {
  const trimmed = path === '/' ? path : path.replace(/\/$/, '');
  const match = trimmed.match(SRP_PATH_WITH_DYNAMIC_SEGMENT);
  if (!match) return trimmed;

  const [, prefix, segment, suffix] = match;
  const isRoleSegment = /\/(?:role|rooli|roll)\//.test(prefix);
  const encoded = encodeDynamicSrpSegment(segment, isRoleSegment);
  return `${prefix}${encoded}${suffix}`;
}
